exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-container[data-v-2d0817f6] {\n  padding: 15px;\n  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);\n  margin-bottom: 30px;\n}\n.btn-info[data-v-2d0817f6] {\n  background-color: #c56e0d;\n  border-color: #c56e0d;\n}", ""]);

// exports
